export const getAccounts = (state) => state.accountCount
export const getInvoices = (state) => state.invoiceCount
export const getPurchaseOrders = (state) => state.purchaseOrderCounts